/** Name categories (labels only, no names): the settings sheet shows these as chips. Every name has one or more. */
export const STAR_CATEGORIES = [
  { id: 'pop', label: 'Pop stars' },
  { id: 'rock', label: 'Rock & legends' },
  { id: 'hiphop', label: 'Hip-hop & R&B' },
  { id: 'actors', label: 'Actors & film-makers' },
  { id: 'movie', label: 'Movie characters' },
  { id: 'tv', label: 'TV characters' },
  { id: 'cartoons', label: 'Cartoons & animation' },
  { id: 'games', label: 'Video games' },
  { id: 'sports', label: 'Sports' },
  { id: 'leaders', label: 'World leaders' },
  { id: 'history', label: 'History & the arts' },
  { id: 'science', label: 'Science & inventors' },
  { id: 'heroes', label: 'Heroes, villains & legends' },
  { id: 'hosts', label: 'TV hosts & internet stars' },
] as const;

export type StarCategory = (typeof STAR_CATEGORIES)[number]['id'];
export const STAR_CATEGORY_IDS = STAR_CATEGORIES.map((c) => c.id) as [StarCategory, ...StarCategory[]];
